import { variablePattern } from '../../src';
var isSegmentHasAtListOneVariable = function (segment) {
    var match = segment.match(new RegExp(variablePattern, 'g'));
    var hasAtListOneVariable = ((match === null || match === void 0 ? void 0 : match.length) || 0) <= 1;
    return hasAtListOneVariable;
};
export var onlyOneVariablePerSegmentValidator = function (value) {
    return value === null || value === void 0 ? void 0 : value.split('/').every(isSegmentHasAtListOneVariable);
};
//# sourceMappingURL=only-one-variable-per-segment-validator.js.map